<app-header [isStudent]="isStudentView || isCurrentStudent"></app-header>
<div class="container">
  <div class="toggle-container" *ngIf="isEvaluator">
    <mat-slide-toggle class="toggle" color=primary (click)="switchStudentView()">
      Student View
    </mat-slide-toggle>
  </div>
  <div class="adminButtonGroup" *ngIf="isAdmin && !isStudentView">
    <button  class="button" mat-raised-button color="primary" [matMenuTriggerFor]="downloadMenu" color="primary" aria-label="Download"><mat-icon>download</mat-icon>Download</button>
    <mat-menu #downloadMenu="matMenu">
      <button (click)="adminMenuClick($event, 'download', 'similarityReport')" mat-menu-item>Similarity Report</button>
      <button (click)="adminMenuClick($event, 'download', 'studentSub')" *ngIf="!isManualUpload"mat-menu-item>Student Submission</button>
      <button (click)="adminMenuClick($event, 'download', 'dbMatches')" mat-menu-item>Copyleaks Database Matches</button>
    </mat-menu>

    <button class="button" mat-raised-button [matMenuTriggerFor]="menu" color="primary" aria-label="Filter Results"><mat-icon>filter_alt</mat-icon>Filter Results</button>
    <mat-menu #menu="matMenu">
      <ul *ngFor="let option of filterOptions">
        <li>
          <mat-checkbox
            class="filterOption"
            color="primary"
            [(ngModel)]="option.checked"
            (click)="adminMenuClick($event, 'filter', option.value)"
          >
            {{ option.viewValue }}
          </mat-checkbox>
        </li>
      </ul>
    </mat-menu>
  </div>
  
</div>

<cr-copyleaks-report id="copyleaksComponent"
  [config]="config"
  (share)="onShareBtnClick($event)">
</cr-copyleaks-report>
